import { render, staticRenderFns } from "./pcEnter.vue?vue&type=template&id=22a97a30&"
import script from "./pcEnter.vue?vue&type=script&lang=js&"
export * from "./pcEnter.vue?vue&type=script&lang=js&"
import style0 from "./pcEnter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports